import { render, staticRenderFns } from "./invitation_notification.vue?vue&type=template&id=65721110&scoped=true"
import script from "./invitation_notification.vue?vue&type=script&lang=js"
export * from "./invitation_notification.vue?vue&type=script&lang=js"
import style0 from "./invitation_notification.vue?vue&type=style&index=0&id=65721110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65721110",
  null
  
)

export default component.exports